export const volunteerIntro = {
    heading: "Volunteering",
    text: "We believe that every organization with the resources has an obligation to work with their community to make it a better place. We volunteer with, and donate to, organizations and causes that are making Montana (and the world) a better place.",
};

export const partners = [
    {
        id: 1,
        title: "The Poverello Center",
        description:
            "The Poverello Center provides food, shelter, and hope to all who ask. We do what we can to help them out through volunteering and donations.",
        link: "https://thepoverellocenter.org/donate/",
        linkText: "Donate →",
        gradientIndex: 0,
    },
    {
        id: 2,
        title: "The Dusty Bandita",
        description:
            "We volunteer as aid station aficionados, crossing guards, parking attendants, cheerleaders, hype men, and more at the Dusty Bandita, the premier women's gravel race in Montana.",
        link: "https://www.thedustybandita.com/",
        linkText: "Check it out →",
        gradientIndex: 1,
    },
    {
        id: 3,
        title: "Fort Belknap Indian Reservation",
        description:
            "Osprey Racing organizes a much-needed winter clothing drive for the Fort Belknap Indian Reservation.",
        gradientIndex: 2,
    },
];
